import { makeRequest } from 'utils/requestLogger';

export default (id) =>
    makeRequest('delete', `/api/courses/${id}/messages`);



// WEBPACK FOOTER //
// ./src/app/services/courses/deleteAllChatMessages.js